// extracted by mini-css-extract-plugin
export default {"viewItem":"view-form_viewItem__MkSt9","viewItemValue":"view-form_viewItemValue__Uo-YB"};